import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-h1",
        "text-h2", 
        "text-h3",
        "text-h4",
        "text-h5",
        "text-h6",
        "text-body",
        "text-caption"
      ]
    },
    conflictingClassGroups: {
      "font-size": ["text-color"]
    }
  }
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Escapes HTML entities in a string to prevent rendering issues in JSX.
 * Converts characters like >, <, & to their HTML entity equivalents.
 */
export function escapeHtmlEntities(text: string): string {
  const entityMap: Record<string, string> = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  };
  return text.replace(/[&<>"']/g, (char) => entityMap[char]);
}